
import forge from 'node-forge';

export const encryptByRSA = (data) => {
    // const stringfyJSON = JSON.stringify(data);
  const publicKeyPEM = `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAz+FFku8luA8qIveT+hSR
1guEZ25/7kBkhwVvjs4tZj12S/VUqvc8TFvmZ6Nh+yoYcpht8AOJx5SEPuvMwZYo
54ikEoeVbUIriwJZZWseJBU5AJ7l8LQKoAqt/OTTnaAORWlnwPf1HqodDQwmo5f1
AjwAi6kFBuf7581ijbuhmh2Bi0nV7/JrxbAnkha4fRGCOrJMc217VBD1pImOxJ5n
7vFEqJiF6kzQfTl88dszD+J83G8smskQZ7yYOqqLQsvY5RUNmbz9QaqRI3r9YyGj
PQrMxDM4tXIFUJ4ePmrDN0zQYhI7p8llzPeLfZLmLN45mUfeOHLXiGC5sbLcCrTB
h3zddRKW5MAASZM+Rh2JvNVmUZXpqkVuOg06iqbhR0WBucpKAXSpW/y+jZvz0MZ6
yjcWpPCoymmOMJSezpUMLwDFSemSMJiQoZXxHDj9oJf/wYRAUi4XZJREFufRo2f5
TbnSgfoSIP+YIZpaM1mr8O56xAPVi9yn/Mnm2bu0djOzlBEeLf1HzrKiakodpNhm
kN4QaNcN1m/m/2F+m9DuD4MoOZWvFodA5GnbWO4x6jukvciXlpDN/bnw1sNvrllT
FJjZ0ZzJRpihxqFVPEG1VT6sQG2Ykf7VKj5823wk9lePC+bhvNyryk5tfKFdn8uR
yCdYxafybjH/tFv9bjoEOyUCAwEAAQ==
-----END PUBLIC KEY-----`;
  const publicKey = forge.pki.publicKeyFromPem(publicKeyPEM);
  const dataBytes = forge.util.createBuffer(data, 'utf8');
  const encryptedBytes = publicKey.encrypt(dataBytes.bytes(), 'RSA-OAEP');
  const encryptedBase64 = forge.util.encode64(encryptedBytes);
  return encryptedBase64;
};
